import React, { useState } from 'react';
import { RichText } from 'prismic-reactjs';

function KnowledgeHubAccordion({ title, content }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="container" onClick={() => setIsOpen((prev) => !prev)}>
        <div className="accordion">
          <p className="text">{title}</p>
          <button className={`${isOpen && 'rotate'} open_button`}>
            <img draggable="false" src={'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Plus_1.png?v=1714570681'} alt={'open-plus'} />
          </button>
        </div>
        {isOpen && <div className="content">{RichText.render(content)}</div>}
      </div>
      <style jsx>{`
        .rotate {
          transform: rotate(45deg);
          transition: all 0.5s ease-in-out;
        }
        .container {
          padding: 20px 0;
          border-bottom: 1px solid rgba(228, 228, 228, 0.2);
          cursor: pointer;
        }
        .content {
          margin-top: 12px;
          font-family: 'Roboto-Medium';
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: left;

          color: #949494;
        }
        .accordion {
          display: flex;
          justify-content: space-between;
        }
        .text {
          font-family: 'Roboto-Medium';
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          padding: 0;
          margin: 0;
          color: #e4e4e4;
        }
        .open_button {
          background: none;
          border: none;
          transition: all 0.5s ease-in-out;
        }
      `}</style>
    </>
  );
}

export default KnowledgeHubAccordion;
